<div class="box ticket-tools-wrap" *ngIf="(tmUser?.isC && tmUser.loggedOffice) || affiliate?.affiliateRole === affiliateRoleEnum.cashier">
    <div class="tab-wrap">
        <div class="tab-item" [class.active]="selectedTab == ticketToolTabEnum.CashierSearch" (click)="changeTab(ticketToolTabEnum.CashierSearch)" i18n="TM Bet Slip@@BetSlip">Bet Slip</div>
        <div class="tab-item active" [class.active]="selectedTab == ticketToolTabEnum.TicketValidation" (click)="changeTab(ticketToolTabEnum.TicketValidation)" i18n="TM Fast Ticket@@FastTicket">Fast Ticket</div>
    </div>

    <app-cashier-search *ngIf="selectedTab == ticketToolTabEnum.CashierSearch"></app-cashier-search>
    <app-fast-ticket-validation *ngIf="selectedTab == ticketToolTabEnum.TicketValidation"></app-fast-ticket-validation>
</div>
